export default {"src":"/_next/static/media/403_Isko.7ba2aa0d.svg","height":241,"width":303};